import { render, staticRenderFns } from "./CampusUser.vue?vue&type=template&id=98a5122e&scoped=true&"
import script from "./CampusUser.vue?vue&type=script&lang=js&"
export * from "./CampusUser.vue?vue&type=script&lang=js&"
import style0 from "./CampusUser.vue?vue&type=style&index=0&id=98a5122e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a5122e",
  null
  
)

export default component.exports